import activityApi from '@/api/activity'
import centerApi from '@/api/center'
import { userUtils } from '@/utils/auth'
const state = {
  addressList: [],
  userRole: '',
  clientInfo: {},
  clientApplyList: [],
  applyLength: 0
}
const mutations = {
  setAddress: (state, addressList) => {
    state.addressList = addressList
  },
  setUserRole: (state, userRole) => {
    state.userRole = userRole
  },
  setClientInfo: (state, clientInfo) => {
    state.clientInfo = clientInfo
  },
  setClientApplyList: (state, clientApplyList) => {
    state.clientApplyList = clientApplyList
  },
  setApplyLength: (state, applyLength) => {
    state.applyLength = applyLength
  }
}
const actions = {
  getAddress: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      activityApi.getAddressList().then(response => {
        if (response.data.resultCode === '0') {
          const { addressList } = response.data.resultData
          commit('setAddress', addressList)
          resolve(addressList)
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateUserRole: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      centerApi.getClientInfo().then(res => {
        let clientInfo = res.data.resultData.clientInfo || {}
        let userRole = res.data.resultData.clientInfo.clientUserDTO.userRole
        commit('setClientInfo', clientInfo)
        if (userRole !== state.userRole) {
          commit('setUserRole', userRole)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getClientApplyList: ({ state, commit }, params) => {
    return new Promise((resolve, reject) => {
      centerApi.queryClientUserApplyList(params).then(response => {
        if (response.data.resultCode === '0') {
          const { clientApplyList } = response.data.resultData
          commit('setClientApplyList', clientApplyList || [])
          let userRole = userUtils.getClientInfo().clientUserDTO.userRole
          if (userRole === '01') {
            commit('setApplyLength', state.clientApplyList.length)
          } else {
            commit('setApplyLength', 0)
          }
          resolve(state.clientApplyList)
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default { state, actions, mutations }
